import { defineMachine } from "../state-machine.js";
/**
 * After-sales and dispute lifecycle (docs/02-domain.md, "After-sales and disputes"). Card 088 adds two moves: a case
 * lapses when the buyer leaves the seller's counter or rejection unanswered, and the buyer may escalate while an
 * agreed outcome is being carried out (the owner's rules of 2026-10-04).
 */
export const afterSaleCase = defineMachine({
    name: "aftersale-case",
    states: [
        "requested",
        "seller_responding",
        "agreed",
        "executing",
        "escalated",
        "under_review",
        "resolved",
        "closed",
        "withdrawn",
    ],
    events: [
        "notify_seller",
        "seller_accept",
        "buyer_accept_counter",
        "escalate",
        "response_timeout",
        "start_execution",
        "execution_complete",
        "start_review",
        "resolve",
        "appeal",
        "close_without_money",
        "withdraw",
        "lapse",
    ],
    initial: "requested",
    transitions: {
        requested: { notify_seller: "seller_responding", withdraw: "withdrawn" },
        seller_responding: {
            seller_accept: "agreed",
            buyer_accept_counter: "agreed",
            escalate: "escalated",
            response_timeout: "escalated",
            withdraw: "withdrawn",
            lapse: "withdrawn",
        },
        agreed: { start_execution: "executing" },
        executing: { execution_complete: "closed", escalate: "escalated" },
        escalated: { start_review: "under_review", withdraw: "withdrawn" },
        under_review: { resolve: "resolved" },
        resolved: { start_execution: "executing", close_without_money: "closed", appeal: "under_review" },
        closed: {},
        withdrawn: {},
    },
});
//# sourceMappingURL=case.machine.js.map